import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/gutter-service-hero.jpg")